/**
 * @description Access version details 
 */
class FileVersionService {
    /**
     * @description Service base URL (without trailing `/`)
     */
    public static base_url: string = import.meta.env.VITE_APP_FILE_VERSION_SERVICE_URL
    public static axios: any

    public static init (axiosInstance: any) {
      FileVersionService.axios = axiosInstance 
    }

    public static get_versions(version_ids: number[], with_generations: boolean = false) {
      const url_params = {
        'version_ids': version_ids.join(','),
        'with_generations': Number(with_generations)
      }
      return FileVersionService.axios.get(`${FileVersionService.base_url}/version`, { params: url_params })
    }

}

export default FileVersionService
